import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../../../base-components/orbit-component/orbit-component';
import {SectionTitleBox} from '../../../../common/boxes/section-title/section-title.box';


export interface PcGamePreviewTitleComponentProps {
    gameTitle: string;
}

@observer
export class PcGamePreviewTitleComponent extends OrbitComponent<PcGamePreviewTitleComponentProps> {

    //className={`game-title general-title game-preview`}
    render() {
        return (
            <SectionTitleBox>
                {this.props.gameTitle}
            </SectionTitleBox>
        );
    }
}